'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const PaymentZarinpalAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: 0.5,
          y: 0.5,
          width: 83,
          height: 57,
          rx: 3.5,
          fill: "white",
          stroke: "#E1E0DF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M27.6921 38.5752C26.545 38.0164 25.5597 36.9722 25.1773 35.9428C24.7508 34.8103 24.8096 32.9279 25.295 31.9279C25.7509 31.0013 51.6344 5.10312 52.605 4.6031C54.208 3.79424 56.0022 3.89718 57.517 4.86781C58.4876 5.5002 58.9876 6.08846 59.4435 7.14733C59.8847 8.14737 59.8112 10.2063 59.3112 11.1916C59.0759 11.6622 55.1345 15.6918 45.8694 25.0011C31.0158 39.8694 32.0306 38.987 29.7363 38.987C28.6775 38.9723 28.3686 38.9135 27.6921 38.5752Z",
          fill: "#FFDB09"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M25.1332 15.4859C24.9126 15.2359 24.8832 14.633 24.8832 9.83863C24.8832 5.01488 24.9126 4.44132 25.1332 4.26485C25.3244 4.10307 26.4274 4.04425 30.5452 4.01483C35.6042 3.97071 35.7219 3.98542 36.1043 4.27955C36.9278 4.94135 36.9278 4.95605 31.3246 10.5592C25.8538 16.0301 25.7215 16.133 25.1332 15.4859Z",
          fill: "#FFDB09"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M59.6309 27.4944C59.8515 27.7444 59.8809 28.3474 59.8809 33.1417C59.8809 37.9655 59.8515 38.539 59.6309 38.7155C59.4397 38.8773 58.3367 38.9361 54.2189 38.9655C49.1598 39.0096 49.0422 38.9949 48.6598 38.7008C47.8362 38.039 47.8362 38.0243 53.4394 32.4211C58.9103 26.9503 59.0426 26.8473 59.6309 27.4944Z",
          fill: "#FFDB09"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M48.149 53.8111C48.0314 53.6934 47.9725 52.9434 47.9725 51.4286C47.9725 48.9285 48.1343 48.3403 48.9873 47.6196C49.5756 47.1196 49.9726 47.0167 50.9874 47.1049C52.4139 47.2226 53.3257 48.2373 53.3257 49.7227C53.3257 50.6933 53.0316 51.3257 52.2816 51.8845C51.8257 52.2375 51.6051 52.2963 50.7815 52.2963C50.2521 52.2963 49.6638 52.2375 49.4873 52.1787C49.1638 52.061 49.1491 52.0904 49.1491 52.7963C49.1491 53.7817 48.6343 54.2964 48.149 53.8111ZM51.958 48.8991C51.1125 47.5212 48.9874 48.3555 49.1932 49.9139C49.5025 52.2336 53.2179 50.9857 51.958 48.8991Z",
          fill: "#06070C"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M39.178 52.2816C38.8692 52.0757 38.8545 51.9434 38.8545 49.7227C38.8545 47.502 38.8692 47.3696 39.178 47.1637C39.3986 47.002 39.5604 46.9873 39.7663 47.0902C40.0016 47.2226 40.031 47.4579 40.031 49.7227C40.031 51.9875 40.0016 52.2228 39.7663 52.3551C39.5604 52.4581 39.3986 52.4434 39.178 52.2816Z",
          fill: "#06070C"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M41.237 52.2816C40.9575 52.0904 40.9134 51.9139 40.9134 50.9286C40.9134 49.6197 41.0752 48.9285 41.5458 48.2373C42.5605 46.7372 45.0459 46.6637 46.2519 48.105C46.8107 48.752 46.9725 49.458 46.9137 50.9727C46.8696 52.2228 46.8548 52.2963 46.5313 52.3404C45.9136 52.4287 45.7666 52.1493 45.7666 50.7962C45.7666 48.9726 45.2518 48.252 43.9282 48.252C42.6488 48.252 42.0899 49.0756 42.0899 50.9727C42.0899 52.0316 42.0458 52.2375 41.8252 52.3551C41.6193 52.4581 41.4576 52.4434 41.237 52.2816Z",
          fill: "#06070C"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M60.7966 52.3404C60.6643 52.2081 60.6202 51.2521 60.6202 48.9579C60.6202 46.0019 60.6349 45.7519 60.8849 45.6195C61.0908 45.5166 61.2525 45.5313 61.4731 45.6931C61.782 45.9137 61.7967 46.0019 61.7967 48.9873C61.7967 51.5757 61.7673 52.0904 61.5614 52.2816C61.282 52.561 61.032 52.5757 60.7966 52.3404Z",
          fill: "#06070C"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M23.1479 52.1934C22.8097 51.8551 22.9861 51.5316 24.3686 49.9139C25.1333 49.0168 25.7657 48.2373 25.7657 48.1932C25.7657 48.1491 25.2068 48.105 24.5156 48.105C23.4567 48.105 23.2509 48.0608 23.1332 47.8255C23.0303 47.6343 23.045 47.4726 23.1773 47.2814C23.3538 47.0608 23.6479 47.002 25.1921 46.9578C26.854 46.899 27.0451 46.9284 27.3834 47.1931C27.854 47.5755 27.7511 47.7814 26.148 49.6491C25.4568 50.458 24.8833 51.1786 24.8833 51.2374C24.8833 51.311 25.3245 51.3551 25.8833 51.3404C26.4275 51.3257 26.9863 51.311 27.1187 51.3257C27.3981 51.3404 27.5746 51.7816 27.4422 52.1345C27.3687 52.3404 27.0746 52.3699 25.3392 52.3699C23.9715 52.3699 23.2656 52.311 23.1479 52.1934Z",
          fill: "#06070C"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M29.7659 52.1198C28.7217 51.6051 28.0893 50.1786 28.3981 49.0315C28.7364 47.8108 29.7217 47.0755 31.0159 47.0755C31.8983 47.0755 32.6042 47.4284 33.1778 48.1491C33.6337 48.7226 33.6337 48.7373 33.6337 50.5021C33.6337 52.1345 33.6043 52.2963 33.3542 52.3404C33.2072 52.3698 32.9425 52.3257 32.766 52.2228C32.5307 52.1051 32.3248 52.1051 32.0307 52.2081C31.4424 52.4434 30.3247 52.3993 29.7659 52.1198ZM31.1041 48.1491C29.1294 47.8959 28.8361 51.1933 30.9718 51.1933C32.8401 51.1933 33.016 48.404 31.1041 48.1491Z",
          fill: "#06070C"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M34.619 52.1934C34.3984 51.9728 34.3837 49.7962 34.6043 49.1197C35.0308 47.8696 36.1632 47.0167 37.2809 47.1049C37.8545 47.149 37.8986 47.1784 37.8986 47.5902C37.8986 47.9432 37.825 48.0461 37.4574 48.1491C35.8691 48.6197 35.6191 49.0168 35.6191 50.958C35.6191 51.9434 35.5749 52.2081 35.3838 52.2816C35.0308 52.414 34.8102 52.3846 34.619 52.1934Z",
          fill: "#06070C"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M55.5905 52.0757C54.164 51.311 53.7963 49.3697 54.8111 48.0167C55.8405 46.6637 58.1642 46.7667 59.1495 48.2079C59.4878 48.7079 59.5172 48.8697 59.5172 50.5168C59.5172 52.1345 59.4878 52.2963 59.2378 52.3404C59.0907 52.3698 58.8113 52.3257 58.6348 52.2228C58.3848 52.0904 58.223 52.0904 58.0024 52.2081C57.5171 52.4728 56.1935 52.3846 55.5905 52.0757ZM56.9141 48.252C54.9164 48.252 55.08 51.1933 56.9582 51.1933C58.7989 51.1933 58.9024 48.252 56.9141 48.252Z",
          fill: "#06070C"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M39.0163 46.3549C38.5188 45.4665 40.1337 45.1546 40.0016 46.1784C39.9428 46.6784 39.2516 46.8108 39.0163 46.3549Z",
          fill: "#06070C"
        }
      )
    ]
  }
);
const VpPaymentZarinpalAsset = forwardRef(PaymentZarinpalAsset);

export { VpPaymentZarinpalAsset as default };
